import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A fallen log — the round tube trunk + pale FLAT cut end-rings stay chunky (a
// sawn log's ends are hard cut faces), with a short tapered-bone branch stub and
// a couple of squashed-ball moss mounds draped on top. Rounded art style, plan 28
// stage 4.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/log.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ tube, bone, ball, seed }) => {
    const bark = shade(0x5a3d22, (rand(seed) - 0.5) * 0.2);
    const len = 2.4 + rand(seed + 1) * 1.4;
    const r = 0.34 + rand(seed + 2) * 0.16;

    tube(0, r, 0, r, len, bark, "x");                                  // trunk on its side
    // pale cut faces (rings) just past each end — hard flat sawn faces
    tube(len / 2 + 0.02, r, 0, r * 0.99, 0.08, shade(bark, 0.22), "x");
    tube(-len / 2 - 0.02, r, 0, r * 0.99, 0.08, shade(bark, 0.22), "x");

    // a short broken branch stub poking up — tapered bone rooted in the trunk
    if (rand(seed + 3) > 0.4) {
      const bx = (rand(seed + 4) - 0.5) * len * 0.5;
      bone(bx, r * 1.2, 0, bx, r * 1.2 + 0.5, 0, r * 0.42, r * 0.18, bark);
    }

    // moss mounds on the upper side — squashed balls (rot flattens the vertical)
    const moss = 0x4a7a3a;
    ball(-len * 0.12, r * 1.7, 0, r * 0.95, moss, 0.5, [Math.PI / 2, 0, 0]);
    ball(len * 0.25, r * 1.72, 0, r * 0.78, shade(moss, 0.08), 0.5, [Math.PI / 2, 0, 0]);
  };

export default build;
